"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildLetterDesignSvgForPcm = exports.buildLetterDesignSvg = exports.namespaceLetterDesignSvgIds = void 0;
const letter_design_catalog_1 = require("../post-mail/letter-design-catalog");
const post_mail_letter_design_color_1 = require("./post-mail-letter-design-color");
const post_mail_letter_design_svgs_1 = require("./post-mail-letter-design-svgs");
const letterDesignBaseColorPattern = new RegExp(post_mail_letter_design_color_1.PostMailLetterDesignDefaultColor.replace("#", "\\#"), "gi");
const substituteLetterDesignColor = (svgTemplate, colorHex) => svgTemplate.replace(letterDesignBaseColorPattern, colorHex);
const namespaceLetterDesignSvgIds = (svg, namespace) => svg
    .replace(/\bid="([^"]+)"/g, (_, id) => `id="${id}-${namespace}"`)
    .replace(/url\(#([^)]+)\)/g, (_, id) => `url(#${id}-${namespace})`);
exports.namespaceLetterDesignSvgIds = namespaceLetterDesignSvgIds;
const buildLetterDesignSvg = ({ designId, colorHex, organizationColor, }) => {
    if (!(0, letter_design_catalog_1.isDecoratedPostMailLetterDesign)(designId)) {
        return null;
    }
    const svgTemplate = post_mail_letter_design_svgs_1.POST_MAIL_LETTER_DESIGN_SVG_BY_ID[designId];
    if (!svgTemplate) {
        return null;
    }
    const resolvedColor = (0, post_mail_letter_design_color_1.resolvePostMailLetterDesignColorValue)(colorHex, organizationColor);
    return substituteLetterDesignColor(svgTemplate, resolvedColor);
};
exports.buildLetterDesignSvg = buildLetterDesignSvg;
const buildLetterDesignSvgForPcm = (input) => (0, exports.buildLetterDesignSvg)(input) ?? "";
exports.buildLetterDesignSvgForPcm = buildLetterDesignSvgForPcm;
